export default __webpack_public_path__ + "static/media/devidebyd~bkWxJaiJ.e947b4f3.svg";